(function () {
  function initRails(root) {
    (root || document).querySelectorAll('[data-ob-rail]').forEach(function (rail) {
      if (rail.dataset.obReady === 'true') return;
      rail.dataset.obReady = 'true';
      var section = rail.closest('[data-ob-rail-section]');
      if (!section) return;
      var prev = section.querySelector('[data-ob-prev]');
      var next = section.querySelector('[data-ob-next]');
      function update() {
        var overflow = rail.scrollWidth > rail.clientWidth + 2;
        if (prev) {
          prev.hidden = !overflow;
          prev.disabled = rail.scrollLeft <= 2;
        }
        if (next) {
          next.hidden = !overflow;
          next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
        }
      }
      function move(direction) {
        rail.scrollBy({ left: direction * Math.max(280, rail.clientWidth * 0.82), behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });
      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function initLocations(root) {
    (root || document).querySelectorAll('[data-ob-locations]').forEach(function (section) {
      if (section.dataset.obReady === 'true') return;
      section.dataset.obReady = 'true';
      var button = section.querySelector('[data-ob-locations-toggle]');
      var track = section.querySelector('[data-ob-locations-track]');
      if (!button || !track) return;
      button.addEventListener('click', function () {
        var paused = track.classList.toggle('is-paused');
        button.setAttribute('aria-pressed', paused ? 'true' : 'false');
        button.setAttribute('aria-label', paused ? 'Play partner locations' : 'Pause partner locations');
        button.classList.toggle('is-paused', paused);
      });
    });
  }

  function initMobileMenu(root) {
    (root || document).querySelectorAll('.ob-mobile-menu').forEach(function (menu) {
      if (menu.dataset.obReady === 'true') return;
      menu.dataset.obReady = 'true';
      var summary = menu.querySelector('summary');
      var panel = menu.querySelector('.ob-mobile-panel');
      if (!summary || !panel) return;
      var isOpen = false;
      var inertRecords = [];

      function updateOffset() {
        var header = menu.closest('.shopify-section-ob-header');
        var bottom = header ? header.getBoundingClientRect().bottom : 91;
        document.documentElement.style.setProperty('--ob-mobile-panel-top', Math.max(0, Math.round(bottom)) + 'px');
      }

      function setBackgroundInert(active) {
        var header = menu.closest('.shopify-section-ob-header');
        var pageContainer = header ? header.closest('.page-container') : null;
        if (active) {
          if (inertRecords.length) return;
          var candidates = [];
          Array.prototype.forEach.call(document.body.children, function (node) {
            if (/^(SCRIPT|STYLE|LINK)$/.test(node.tagName)) return;
            if (pageContainer && node === pageContainer) {
              Array.prototype.forEach.call(pageContainer.children, function (child) {
                if (child !== header) candidates.push(child);
              });
              return;
            }
            if (header && (node === header || node.contains(header) || header.contains(node))) return;
            candidates.push(node);
          });
          candidates.forEach(function (node) {
            inertRecords.push({
              node: node,
              inert: node.inert,
              ariaHidden: node.getAttribute('aria-hidden')
            });
            if ('inert' in node) node.inert = true;
            else node.setAttribute('aria-hidden', 'true');
          });
          return;
        }

        inertRecords.forEach(function (record) {
          if ('inert' in record.node) record.node.inert = record.inert;
          if (record.ariaHidden === null) record.node.removeAttribute('aria-hidden');
          else record.node.setAttribute('aria-hidden', record.ariaHidden);
        });
        inertRecords = [];
      }

      function focusableItems() {
        return [summary].concat(Array.prototype.slice.call(panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')));
      }

      function setState() {
        var open = menu.open && window.matchMedia('(max-width: 980px)').matches;
        document.documentElement.classList.toggle('ob-mobile-nav-open', open);
        document.body.classList.toggle('ob-mobile-nav-open', open);
        summary.setAttribute('aria-expanded', open ? 'true' : 'false');
        summary.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
        panel.setAttribute('aria-hidden', open ? 'false' : 'true');
        if (open) {
          updateOffset();
          if (!isOpen) {
            panel.scrollTop = 0;
            setBackgroundInert(true);
            window.requestAnimationFrame(function () { summary.focus({ preventScroll: true }); });
          }
        } else if (isOpen) {
          setBackgroundInert(false);
        }
        isOpen = open;
      }

      menu.addEventListener('toggle', setState);
      panel.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          menu.open = false;
          setState();
        });
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && isOpen) {
          menu.open = false;
          setState();
          summary.focus({ preventScroll: true });
          return;
        }
        if (event.key === 'Tab' && isOpen) {
          var items = focusableItems();
          var first = items[0];
          var last = items[items.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          } else if (!menu.contains(document.activeElement)) {
            event.preventDefault();
            first.focus();
          }
        }
      });
      document.addEventListener('focusin', function (event) {
        if (isOpen && !menu.contains(event.target)) summary.focus({ preventScroll: true });
      });
      window.addEventListener('resize', function () {
        if (window.innerWidth > 980 && menu.open) menu.open = false;
        updateOffset();
        setState();
      });
      window.addEventListener('orientationchange', updateOffset);
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', updateOffset);
        window.visualViewport.addEventListener('scroll', updateOffset);
      }
      setState();
    });
  }

  function initRequiredChecks(root) {
    (root || document).querySelectorAll('[data-ob-required-checks]').forEach(function (fieldset, index) {
      if (fieldset.dataset.obReady === 'true') return;
      fieldset.dataset.obReady = 'true';
      var boxes = Array.prototype.slice.call(fieldset.querySelectorAll('input[type="checkbox"]'));
      var error = fieldset.querySelector('.ob-form-checks__error');
      var form = fieldset.closest('form');
      if (!boxes.length || !form) return;
      var first = boxes[0];
      var attempted = false;

      if (error) {
        if (!error.id) error.id = 'ob-form-checks-error-' + index;
        first.setAttribute('aria-describedby', error.id);
      }

      function sync(showError) {
        var valid = boxes.some(function (box) { return box.checked; });
        first.setCustomValidity(valid ? '' : 'Select at least one product.');
        fieldset.classList.toggle('is-invalid', !valid && showError);
        if (error) error.hidden = valid || !showError;
        return valid;
      }

      boxes.forEach(function (box) {
        box.addEventListener('change', function () { sync(attempted); });
      });
      first.addEventListener('invalid', function () {
        attempted = true;
        sync(true);
      });
      form.addEventListener('submit', function (event) {
        attempted = true;
        if (!sync(true)) {
          event.preventDefault();
          first.reportValidity();
          first.focus();
        }
      });
      sync(false);
    });
  }

  function initProductCardHoverImages(root) {
    var selector = '.ob-card__image--secondary, .product-card__img-hover';
    var scope = root || document;
    var images = [];
    if (scope.nodeType === 1 && scope.matches(selector)) images.push(scope);
    Array.prototype.push.apply(images, scope.querySelectorAll(selector));

    images.forEach(function (image) {
      if (image.dataset.obHoverBound === 'true') return;
      image.dataset.obHoverBound = 'true';
      var container = image.closest('.ob-card__media-link--has-hover, .product-card__media--hover');
      if (!container) return;
	  var primary = container.querySelector('.ob-card__image--primary, .product-card__img');

      function markReady() {
        if (!image.naturalWidth || !image.naturalHeight) {
          markUnavailable();
          return;
        }
		if (primary && image.currentSrc && primary.currentSrc && image.currentSrc === primary.currentSrc) {
		  markUnavailable();
		  return;
		}
        image.classList.add('is-hover-ready');
        container.classList.add('is-hover-ready');
      }

      function markUnavailable() {
        image.classList.remove('is-hover-ready');
        container.classList.remove('is-hover-ready');
        container.classList.remove('ob-card__media-link--has-hover');
        container.classList.remove('product-card__media--hover');
        image.remove();
      }

      image.addEventListener('load', markReady);
      image.addEventListener('error', markUnavailable);
      if (image.complete) {
        if (image.naturalWidth && image.naturalHeight) markReady();
        else markUnavailable();
      }
    });

    if (scope === document && !window.obProductCardHoverObserver && document.body) {
      window.obProductCardHoverObserver = new MutationObserver(function (records) {
        records.forEach(function (record) {
          Array.prototype.forEach.call(record.addedNodes, function (node) {
            if (node.nodeType === 1) initProductCardHoverImages(node);
          });
        });
      });
      window.obProductCardHoverObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  function initDesktopNavigation(root) {
    (root || document).querySelectorAll('.ob-nav__drop').forEach(function (details) {
      if (details.dataset.obReady === 'true') return;
      details.dataset.obReady = 'true';
      var summary = details.querySelector('summary');
      document.addEventListener('click', function (event) {
        if (details.open && !details.contains(event.target)) details.open = false;
      });
      details.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || !details.open) return;
        details.open = false;
        if (summary) summary.focus();
      });
    });
  }

  function initStatusMessages(root) {
    (root || document).querySelectorAll('[role="status"][tabindex="-1"]').forEach(function (message) {
      if (message.dataset.obAnnounced === 'true') return;
      message.dataset.obAnnounced = 'true';
      window.requestAnimationFrame(function () { message.focus({ preventScroll: true }); });
    });
  }

  function initShopifyCollabsLinks(root) {
    var scope = root || document;
    var links = [];
    if (scope.matches && scope.matches('a[href^="https://api.collabs.shopify.com/"]')) links.push(scope);
    if (scope.querySelectorAll) {
      links = links.concat(Array.prototype.slice.call(scope.querySelectorAll('a[href^="https://api.collabs.shopify.com/"]')));
    }
    links.forEach(function (link) {
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
    });

    if (scope === document && !window.obCollabsLinkObserver && document.body) {
      window.obCollabsLinkObserver = new MutationObserver(function (records) {
        records.forEach(function (record) {
          Array.prototype.forEach.call(record.addedNodes, function (node) {
            if (node.nodeType === 1) initShopifyCollabsLinks(node);
          });
        });
      });
      window.obCollabsLinkObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  function init(root) {
    initRails(root);
    initLocations(root);
    initMobileMenu(root);
    initRequiredChecks(root);
    initProductCardHoverImages(root);
    initDesktopNavigation(root);
    initStatusMessages(root);
    initShopifyCollabsLinks(root);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
